"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var UserInfoConverter_1 = require("../../user/conversions/UserInfoConverter");

var PromotionArea_1 = require("../model/PromotionArea");

var PromotionAreaConverter_1 = require("./PromotionAreaConverter");
/**
 * Implementation of {@link PromotionAreaConverter PromotionAreaConverter}
 * @author OPt
 */


var PromotionAreaConverterImpl =
/*#__PURE__*/
function (_PromotionAreaConvert) {
  _inherits(PromotionAreaConverterImpl, _PromotionAreaConvert);

  function PromotionAreaConverterImpl(userInfoConverter) {
    var _this;

    _classCallCheck(this, PromotionAreaConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PromotionAreaConverterImpl).call(this));
    _this.userInfoConverter = userInfoConverter;
    return _this;
  }

  _createClass(PromotionAreaConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new PromotionArea_1.PromotionArea(PromotionArea_1.PromotionArea.schema.id.valueOf(conversions.documentToClassId(source)), PromotionArea_1.PromotionArea.schema.externalId.valueOfField(source), PromotionArea_1.PromotionArea.schema.name.valueOfField(source), PromotionArea_1.PromotionArea.schema.active.valueOfField(source), PromotionArea_1.PromotionArea.schema.invalidated.valueOfField(source), PromotionArea_1.PromotionArea.schema.processed.valueOfField(source));
    }
  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        externalId: source.externalId,
        name: source.name,
        active: source.active,
        invalidated: conversions.asObjectOpt(source, 'invalidated', function (v) {
          return conversions.fromDate(v);
        }),
        processed: source.processed
      });
      return result;
    }
  }]);

  return PromotionAreaConverterImpl;
}(PromotionAreaConverter_1.PromotionAreaConverter);

PromotionAreaConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [UserInfoConverter_1.UserInfoConverter])], PromotionAreaConverterImpl);
exports.PromotionAreaConverterImpl = PromotionAreaConverterImpl;